import * as Actions from 'app/store/actions/members/members.actions';

const initialState = {
	entities: null,
	searchMember: '',
	routeParams: {},
	contactDialog: {
		type: 'new',
		props: {
			open: false
		},
		data: null
	},
	handleDataDetails: [],
	searchProject: '',
	searchFilterCheckbox:[],
	handlingFilteredData:[],
	statusMember: null,
	getMemberTypePublic: '',
	getGroupTypePublic: '',
	getUserPositionPublic: '',
	getAffiliationPublic:'',
	getMemberTypePrivate: '',
	getGroupTypePrivate:'',
	getAffiliationPrivate:'',
	getUserPositionPrivate:'',
	createMember: [],
	updateMember:[],
	membersResponse: '',
	members_companyDetails:'',
	handleMembers_projectSelected:[],
	members_getProjectBranch:[],
	members_getProjects:[],
	members_selectedProjectName:null,
	getMembersMapping:[],
	addMembersMapping:[],
	removeUserFromProjectSelected:[],
	removeProjectFromMember:[],
	handlingResponseMembersPage: false,
	memberPageClickFlag: '',
	memberPageRefreshDataFlag:false,
};

const membersReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_MEMBERS: {
			//console.log('MEMBERS REDUCERS', action.payload);
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.RESET_GET_MEMBERS: {
			return {
				...state,
				entities: initialState.entities,
			};
		}
		case Actions.HANDLING_FILTERED_DATA: {
			return {
				...state,
				handlingFilteredData: action.payload,
			};
		}
		case Actions.SET_FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
		}
		case Actions.HANDLE_DATA_DETAILS: {
			return {
				...state,
				handleDataDetails: action.payload,
			};
		}
		case Actions.MEMBER_SEARCH_TEXT: {
			return {
				...state,
				searchMember: action.searchMember,
			};
		}
		case Actions.PROJECT_SEARCH_TEXT: {
			return {
				...state,
				searchProject: action.searchProject,
			};
		}
		case Actions.OPEN_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: true
					},
					data: null
				}
			};
		}
		case Actions.CLOSE_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.OPEN_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: true
					},
					data: action.data
				}
			};
		}
		case Actions.CLOSE_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.STATUS_MEMBER: {
			return {
				...state,
				statusMember: action.payload,
			};
		}
		case Actions.GET_PUBLIC_MEMBER_TYPE: {
			return {
				...state,
				getMemberTypePublic: action.payload,
			};
		}
		case Actions.GET_PUBLIC_GROUP_TYPE: {
			return {
				...state,
				getGroupTypePublic: action.payload,
			};
		}
		case Actions.GET_PUBLIC_USER_POSITION: {
			return {
				...state,
				getUserPositionPublic: action.payload,
			};
		}
		case Actions.GET_PUBLIC_AFFILIATION: {
			return {
				...state,
				getAffiliationPublic: action.payload,
			};
		}
		case Actions.GET_PRIVATE_MEMBER_TYPE: {
			return {
				...state,
				getMemberTypePrivate: action.payload,
			};
		}
		case Actions.GET_PRIVATE_GROUP_TYPE: {
			return {
				...state,
				getGroupTypePrivate: action.payload,
			};
		}
		case Actions.GET_PRIVATE_AFFILIATION: {
			return {
				...state,
				getAffiliationPrivate: action.payload,
			};
		}
		case Actions.GET_PRIVATE_USER_POSITION: {
			return {
				...state,
				getUserPositionPrivate: action.payload,
			};
		}
		case Actions.CREATE_MEMBER: {
			return {
				...state,
				createMember: action.payload,
			};
		}
		case Actions.UPDATE_MEMBER: {
			return {
				...state,
				updateMember: action.payload,
			};
		}
		case Actions.HANDLE_MEMBERS_RESPONSE: {
			console.log('RECEBENDO NO REDUCER MEMBERS RESPONSE', action.payload)
			return {
				...state,
				membersResponse: action.payload,
			};
		}
		case Actions.MEMBERS_COMPANY_DETAILS: {
			return {
				...state,
				members_companyDetails: action.payload,
			};
		}
		case Actions.HANDLE_MEMBERS_PROJECT_SELECTED: {
			return {
				...state,
				handleMembers_projectSelected: action.payload,
			};
		}
		case Actions.MEMBERS_GET_PROJECT_BRANCH: {
			return {
				...state,
				members_getProjectBranch: action.payload,
			};
		}
		case Actions.MEMBERS_GET_PROJECTS: {
			return {
				...state,
				members_getProjects: action.payload,
			};
		}
		case Actions.MEMBERS_SELETED_PROJECTNAME: {
			return {
				...state,
				members_selectedProjectName: action.payload,
			};
		}
		case Actions.GET_MEMBERS_MAPPING: {
			return {
				...state,
				getMembersMapping: action.payload,
			};
		}
		case Actions.ADD_MEMBER_MAPPING: {
			return {
				...state,
				addMembersMapping: action.payload,
			};
		}
		case Actions.REMOVE_USER_FROM_PROJECT_SELECTED: {
			return {
				...state,
				removeUserFromProjectSelected: action.payload,
			};
		}
		case Actions.REMOVE_PROJECT_FROM_MEMBER: {
			return {
				...state,
				removeProjectFromMember: action.payload,
			};
		}
		case Actions.HANDLING_RESPONSE_MEMBERS_PAGE: {
			return {
				...state,
				handlingResponseMembersPage: action.payload,
			};
		}
		case Actions.MEMBER_PAGE_CLICK_FLAG: {
			return {
				...state,
				memberPageClickFlag: action.payload,
			};
		}
		case Actions.MEMBER_PAGE_REFRESH_DATA_FLAG: {
			return {
				...state,
				memberPageRefreshDataFlag: action.payload,
			};
		}

		default: {
			return state;
		}
	}
};

export default membersReducer;
